/**
 * State passed when leaving the portfolio for a case study, so "Back to Portfolio"
 * can return to the same scroll position instead of jumping to the hero.
 */
export function buildLeavePortfolioState() {
  return {
    restoreScrollY: window.scrollY,
    restorePath: window.location.pathname || '/',
  };
}

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {unknown} locationState — `useLocation().state` from the case study page
 * @param {string} fallbackSectionId — e.g. "selected-work" or "playground" (no leading #)
 */
export function navigateBackToPortfolio(navigate, locationState, fallbackSectionId) {
  const state = locationState && typeof locationState === 'object' ? locationState : {};
  const rawPath = typeof state.restorePath === 'string' && state.restorePath
    ? state.restorePath
    : '/';
  const path = rawPath === '/recruiter' ? '/' : rawPath;
  const y = state.restoreScrollY;
  if (typeof y === 'number' && !Number.isNaN(y)) {
    navigate(path, { state: { restoreScrollY: y } });
    return;
  }
  const hash = fallbackSectionId ? `#${fallbackSectionId.replace(/^#/, '')}` : '';
  navigate(`${path}${hash}`);
}
